import { cleanup, render, screen } from '@testing-library/react';
import * as React from 'react';

import translations from '../../translations';
import Download from './download';

translations.init();

function TestComponent() {
  return <Download />;
}

describe('download icon', () => {
  afterEach(() => {
    cleanup();
  });

  test('should render the download icon', () => {
    render(<TestComponent />);
    const svg = screen.getByTestId('download');

    expect(svg).toBeDefined();
    expect(svg.firstChild.nodeName.toLowerCase()).toBe('path');
  });
});
